import React from 'react';
import { t } from '../translate';

export function useLabels(
	labels?: [
		string,
		{
			en?: string;
		}
	][]
) {
	const customLabels = React.useMemo(() => {
		return new Map(labels);
	}, [labels]);
	return React.useCallback(
		(key: string, options: any) => {
			const customLabel = customLabels.get(key);
			if (!customLabel) {
				return t(key, options);
			}
			const translationValue = customLabel['en'];
			if (!translationValue) {
				return t(key, options);
			}
			return translationValue;
		},
		[customLabels]
	);
}
